<template>
  <div class="home-loading" v-loading="true" element-loading-background="rgba(255, 255, 255, 1)"></div>
</template>

<script setup>
</script>

<style scoped>
.home-loading {
  width: 100vw;
  height: 100vh;
  background: #fff;
}
</style>
